import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';
import { Subject, takeUntil } from 'rxjs';

import { TruncatedMarkdownComponent } from '../truncated-markdown/truncated-markdown.component';
import { TeaItemSummaryComponent } from '../tea-item-summary/tea-item-summary.component';
import { TeaItemListResolverData } from './tea-item-list.resolver';

@Component({
    selector: 'tea-shop-fe-tea-item-list',
    templateUrl: './tea-item-list.component.html',
    styleUrl: './tea-item-list.component.css',
    imports: [
    TruncatedMarkdownComponent,
    TeaItemSummaryComponent
],
})
export class TeaItemListComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private metaDataService = inject(MetaDataService);
  private logger = inject(NGXLogger);


  teaItem: any | null = null;
  teaItemProducts: any[] = [];
  teaItemSlug: string;
  errors: string[] = [];
  private destroy$ = new Subject<void>();

  constructor() {
    this.teaItemSlug = '';
  }

  ngOnInit() {
    // Subscribe to route data changes instead of using snapshot
    this.route.data.pipe(
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      this.updateComponentData(data);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateComponentData(data: Data) {
    // Reset component state
    this.teaItem = null;
    this.errors = [];
    
    // Get the resolved data from the route
    const teaItemListData: TeaItemListResolverData = data['teaItemListData'];
    
    if (teaItemListData) {
      this.teaItem = teaItemListData.teaItem;
      this.errors = teaItemListData.errors;
      
      // Update metadata if tea item is available
      if (this.teaItem) {
        const extraTitle = this.teaItem.teaType && this.teaItem.teaRegion ? 
          ` ${this.teaItem.teaType.name} from ${this.teaItem.teaRegion.name}` : '';
        this.metaDataService.updateMetadata({
          title: `${this.teaItem.name}${extraTitle} - Sencha Tea`,
        });
      }
    } else {
      this.errors.push('Failed to load tea item data.');
    }
  }
}
